var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationMarkAsReadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 7.2487V15.4987C18.3333 16.507 17.5083 17.332 16.5 17.332H3.66667L0 20.9987V4.4987C0 3.49036 0.825 2.66536 1.83333 2.66536H11.0917C11 2.94036 11 3.30703 11 3.58203C11 6.1487 13.0167 8.16537 15.5833 8.16537C16.5917 8.16537 17.6 7.7987 18.3333 7.2487ZM12.8333 3.58203C12.8333 5.14037 14.025 6.33203 15.5833 6.33203C17.1417 6.33203 18.3333 5.14037 18.3333 3.58203C18.3333 2.0237 17.1417 0.832031 15.5833 0.832031C14.025 0.832031 12.8333 2.0237 12.8333 3.58203Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationMarkAsReadIcon);
export default __webpack_public_path__ + "static/media/notification-mark-as-read-icon.ae16152b8098f7aad6c329007bbde97d.svg";
export { ForwardRef as ReactComponent };